module.exports = __webpack_public_path__ + "de1f0752e3e844a7b676111960288b68.svg";